
import { VerificationResponse } from "../types";

/**
 * 模拟券码验证逻辑。
 * 11: 成功进入详情
 * 22: 门店不符错误
 * 33: 码无效错误
 */
export const verifyVoucher = async (code: string): Promise<VerificationResponse> => {
  await new Promise(resolve => setTimeout(resolve, 600));
  
  if (code === "11") {
    return {
      isValid: true,
      message: "获取详情成功"
    };
  } else if (code === "22") {
    return {
      isValid: false,
      message: "SHOP_MISMATCH" // 门店不匹配标识
    };
  } else if (code === "33") {
    return {
      isValid: false,
      message: "INVALID_CODE" // 码无效标识
    };
  } else {
    // 默认回退到详情 (模拟扫描其他真实码也进入详情)
    return {
      isValid: true,
      message: "获取详情成功"
    };
  }
};
